import { useSeamlyCommands } from 'ui/hooks/seamly-hooks'
import { actionTypes } from 'ui/utils/seamly-utils'

const useEventLinkClickHandler = ({ originMessage, transactionId }) => {
  const { emitEvent, sendAction } = useSeamlyCommands()

  const eventClick = (e) => {
    if (e.target && e.target.dataset.linkId) {
      const action = {
        type: actionTypes.navigate,
        originMessage,
        transactionId,
        link: {
          id: e.target.dataset.linkId,
          url: e.target.getAttribute('href'),
        },
      }
      sendAction(action)
      emitEvent(`action.${action.type}`, action)
    }
  }

  return eventClick
}

export default useEventLinkClickHandler
